/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./api";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getRetriggers = /* GraphQL */ `query GetRetriggers($traceId: String!) {
  getRetriggers(traceId: $traceId) {
    items {
      hashKey
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRetriggersQueryVariables,
  APITypes.GetRetriggersQuery
>;
